import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const LocationPinIcon = ({ className = '', width = 18,  height = 24 , color = 'currentColor' }) => {
    return (
        <svg
            className={className ? className : ''}
            fill='none'
            height={height}
            viewBox='0 0 18 24'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                clipRule='evenodd'
                d='M0 8.76C0 3.92949 3.9218 0 8.74286 0C13.5639 0 17.4857 3.92949 17.4857 8.76C17.4857 15.33 8.74286 24 8.74286 24C8.74286 24 0 15.33 0 8.76ZM8.74343 13.7143C11.5838 13.7143 13.8863 11.4118 13.8863 8.57145C13.8863 5.73113 11.5838 3.4286 8.74343 3.4286C5.90311 3.4286 3.60057 5.73113 3.60057 8.57145C3.60057 11.4118 5.90311 13.7143 8.74343 13.7143Z'
                fill={color}
                fillRule='evenodd'/>
        </svg>


    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default LocationPinIcon;
